// Centralized image registry for the site.
// Replace placeholder editorial images with Hallie's professional photography.

export const HALLIE = {
  // Light editorial — cream outfit, columns of light (best for hero / soft sections)
  heroLight: 'https://customer-assets.emergentagent.com/job_ops-excellence-28/artifacts/hizdltk5_20260520_011235-IMG_STYLE.jpg',
  // Cream outfit, geometric white architecture
  editorial2: 'https://customer-assets.emergentagent.com/job_ops-excellence-28/artifacts/cu3ypn93_20260520_011108-IMG_STYLE.jpg',
  // Cream outfit, concrete wall with diagonal light (motion/lifestyle)
  motion: 'https://customer-assets.emergentagent.com/job_ops-excellence-28/artifacts/6dwvkigx_20260520_011213-IMG_STYLE.jpg',
  // Gray power suit — concrete wall (about / professional)
  power: 'https://customer-assets.emergentagent.com/job_ops-excellence-28/artifacts/4s3llmod_20260520_010638-IMG_STYLE.jpg',
  // All-black powerful silhouette — dramatic shadow (eureka1 / dark sections)
  dark: 'https://customer-assets.emergentagent.com/job_ops-excellence-28/artifacts/euqbi532_20260520_010613-IMG_STYLE.jpg',
};
